import { twMerge } from 'tailwind-merge';

interface IGroupInfoSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-12 w-12 border-4',
};

export const GroupInfoSpinner = ({ size = 'md', className }: IGroupInfoSpinnerProps) => {
  return (
    <div
      className={twMerge(
        'animate-spin rounded-full border-gray-300 border-t-orange-500',
        sizeMap[size],
        className,
      )}
    />
  );
};
